module.exports = __webpack_public_path__ + "media/safe_claim_faq_old.fc42cf81.mp4";